import * as React from "react";
import { ArrowNarrow } from "../../../assets/svg/ArrowNarrow";
import { SvgContainer } from "../svg-container/SvgContainer";
export var TradeTransitionArrow = function (_a) {
    var children = _a.children;
    return (React.createElement(SvgContainer, { name: "ArrowNarrowSmall", svg: ArrowNarrow }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/TradeTransitionArrow.tsx
// module id = 306
// module chunks = 3